import { useMemo } from 'react';
import { apiHolder } from 'api';
import { useAppSelector } from '@web-common/state/createStore';
const systemApi = apiHolder.api.getSystemApi();
const HIDE_NICKNAME_DOMAINS = ['xdf.cn', 'lx901.com'];
const useHideNicknameSetting = () => {
    const orgInfo = useAppSelector(state => state.loginReducer.orgInfo);
    const userInfo = systemApi.getCurrentUser();
    return useMemo(() => {
        var _a;
        const list = orgInfo === null || orgInfo === void 0 ? void 0 : orgInfo.domain_list;
        let domainStrings;
        if (Array.isArray(list) && list.length > 0) {
            domainStrings = list.map(({ domain }) => domain).filter(Boolean);
        }
        else {
            const raw = (_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) === null || _a === void 0 ? void 0 : _a.split('@')[1];
            domainStrings = raw ? [raw] : [];
        }
        return HIDE_NICKNAME_DOMAINS.some(d => domainStrings.includes(d));
    }, [orgInfo, userInfo]);
};
export default useHideNicknameSetting;
